import React from "react";
import { withStyles } from "@mui/styles";
import TextField from "@mui/material/TextField";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";

import Label from "../label/Label";

const styles = (theme) => ({
  datePickerInput: {
    marginBottom: "10px",
  },
  input: {
    width: "100%",
    border: "1px solid #D7D7D7",
    borderRadius: "3px",
    outline: "none",
    paddingLeft: "10px",
    paddingTop: "10px",
    paddingBottom: "10px",
    fontSize: "18px",
  },
  invalidInput: {
    border: "1px solid red",
  },
});

function DatePickerInput({
  classes,
  style,
  value,
  label,
  type,
  showInvalidInput,
  onChange,
  required,
}) {
  // let inputClassName = classes.input;

  // if (showInvalidInput) {
  //   inputClassName += ` ${classes.invalidInput}`;
  // }

  console.log("value", value);

  return (
    <div className={classes.datePickerInput} style={style || {}}>
      {label && <Label title={label} required={required} />}
      <DatePicker
        value={value}
        onChange={(newValue) => {
          console.log("newValue", newValue);
          onChange(new Date(newValue));
        }}
        style={{ marginRight: 10 }}
        renderInput={(params) => <TextField {...params} variant="outlined" />}
      />
    </div>
  );
}

export default withStyles(styles)(DatePickerInput);
